
import checkService from './check-service';
import { ossBase } from '@/libs/env';

export const fileTypeMap = {
  'image/jpeg': 'jpeg',
  'image/png': 'png',
  'application/pdf': 'pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.ms-excel': 'xlsx',
  'application/msword': 'docx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/x-zip-compressed': 'zip',
  'application/zip': 'zip',
};

export default {
  // 选择文件
  chooseFile(options) {
    return new Promise((resolve, reject) => {
      const finalOptions = Object.assign(
        {},
        {
          accept: '*',
          multiple: false,
          checkOptions: {
            acceptErrorMsg: undefined,
          },
        },
        options,
      );

      const originInput = document.querySelector('#global-file-input');

      if (originInput) {
        originInput.remove();
      }

      const input = document.createElement('input');
      input.type = 'file';
      input.id = 'global-file-input';
      input.accept = finalOptions.accept;
      if (finalOptions.multiple) input.multiple = true;
      input.onchange = async () => {
        const file = input.files ? input.files[0] : '';
        if (!file) return reject();
        if (finalOptions.multiple) {
          let filesList = [];
          filesList = Array.from(input.files);

          const error = await checkService.checkFileList(filesList, {
            accept: finalOptions.accept,
            size: finalOptions.size ? finalOptions.size : undefined,
            ...finalOptions.checkOptions,
          });

          if (error) {
            reject();
          } else {
            resolve(filesList);
          }
        } else {
          const error = await checkService.checkFile(file, {
            accept: finalOptions.accept,
            size: finalOptions.size ? finalOptions.size : undefined,
          });
          if (error) {
            reject();
          } else {
            resolve(file);
          }
        }
        input.value = '';
      };
      document.body.appendChild(input);
      input.click();
    });
  },
  // 新的上传
  // 根据URL获取文件名和后缀
  getFileNameAndSuffixByUrl(url) {
    if (!url) return {};
    // 把目录等去除
    let fullFileName = url.split('/').pop();
    // 把？号后面参数去除
    fullFileName = fullFileName ? fullFileName.split('?')[0] : '';

    const dotIndex = fullFileName.lastIndexOf('.');

    return {
      filename: fullFileName.substring(0, dotIndex),
      suffix: fullFileName.substring(dotIndex + 1).toLowerCase(),
    };
  },
  // 获得全的URL
  getOssFullUrl(key) {
    if (key.indexOf('http') > -1) {
      return key; 
    }
    return `${ossBase}/${key}`;
  },
};



// WEBPACK FOOTER //
// ./src/services/file-service.js